<template>
	<div class="calendar">
		<div class="container" style="border-radius: 1em;">
			<div class="my-events">
				<div class="c-lightish f-bold" style="margin-bottom: 1em;font-size:1.3em;">Calendario Eximus Class</div>

				<div class="events">
					<div class="event" v-for="ev in myEvents.slice(0, 3)" :key="ev.id" :class="{'past': $moment(ev.start.dateTime).isBefore($moment()), 'dropped': ev.bDropped}">
						<div class="date">
							<div class="giorno">{{ ev.start.dateTime | moment('ddd') }}</div>
							<div class="day">{{ ev.start.dateTime | moment('DD') }}</div>
							<div class="month">{{ ev.start.dateTime | moment('MMM') }}</div>
						</div>
						
						<div class="info">
							<div class="name">{{ ev.summary }}</div>
							<div class="action-bar">
								<span class="time">
									<i class="far fa-clock"></i> {{ ev.start.dateTime | moment('HH:mm') }} &bull; 

									<span v-if="!ev.bDropped">iscritto il {{ ev.subDate | moment('D MMM') }}</span>
									<span v-else>La prenotazione è stata cancellata nelle 24 ore precedenti l'allenamento quindi verrà scalata in automatico.</span>
								</span>
							</div>
						</div>
						
						<div class="d-flex middle">
							<Options :options="{'Cancella prenotazione': () => $emit('dropout', ev)}"/>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="container">
			<div class="grid">
				<div class="day-literal" v-for="day in ['lun', 'mar', 'mer', 'gio', 'ven', 'sab', 'dom']" :key="day">{{ day }}</div>

				<div class="month-day" v-for="i in 14" :key="i">
					<div class="day-number" :class="{'today': $moment().day(0).add(i, 'days').isSame($moment(), 'day')}">
						<span>{{ $moment().day(0).add(i, 'days').date() }}</span>
					</div>

					<!-- <div class="day-events" v-if="!user || !user.membership">
						<div class="event" v-for="ev in eventsPerDay[i - 1]" :key="ev.id"
							:class="{'enrolled': ev.bSub, 'dropped': ev.bDropped, 'full': ev.numSubs >= 10, 'past': $moment(ev.start.dateTime).isBefore($moment())}">
							<div class="name">{{ ev.summary }}</div>
							<div class="info">
								<span class="far fa-clock fa-fw"></span>
								<span class="time">{{ ev.start.dateTime | moment('HH:mm') }}</span>
								<span style="margin: auto 0.4em;">&bull;</span>
								<span class="availability"></span>
								<div style="color:yellow; font-weight:bold;">Accedi a Eximus Online Training per prenotarti!</div>
							</div>
						</div>
					</div> -->
					<div class="day-events">
						<div class="event" v-for="ev in eventsPerDay[i - 1]" :key="ev.id"
							:class="{'enrolled': ev.bSub, 'dropped': ev.bDropped, 'full': ev.numSubs >= 6, 'disp1': ev.numdisp == 1, 'disp2': ev.numdisp == 2, 'disp3': ev.numdisp == 3, 'disp4': ev.numdisp == 4, 'disp5': ev.numdisp == 5, 'disp6': ev.numdisp == 6, 'past': $moment(ev.start.dateTime).isBefore($moment())}"
							@click="showEventActions(ev)">
							<div class="name">{{ ev.summary }}</div>
							<div class="info">
								<span class="far fa-clock fa-fw"></span>
								<span class="time">{{ ev.start.dateTime | moment('HH:mm') }}</span>
								<span style="margin: auto 0.4em;">&bull;</span>
								<span class="availability"></span>
							</div>
							<div class="numposti">
									<span class="posti"></span>
							</div>
						</div>
					</div>
				</div>
			</div>

			

		</div>
	</div>
</template>

<script>
import api from '@/api'
import { notif } from '@/pop'
import EventAction from '@/components/dashboard/EventAction'

export default {
	name: 'calendar',
	
	props: {
		/// User data
		user: {
			type: Object,
			required: true
		},

		events: {
			type: Array,
			required: true
		}
	},

	computed: {
		/**
		 * 
		 */
		eventsPerDay() {

			let events = []
			let start = this.$moment().day(1).startOf('day')

			const numEvents = this.events.length
			for (let day = 0, i = 0; day < 28; ++day)
			{
				// Create new day
				let today = this.$moment(start).add(day, 'd')
				let dayEvents = events[events.push([]) - 1]

				while (i < numEvents)
				{
					const event = this.events[i]
					const startDate = this.$moment(event.start.dateTime)

					if (startDate.date() === today.date())
					{
						dayEvents.push(event)
						i++
					}
					else break
				}
			}

			return events
		},

		/**
		 * List of events user is subscribed to
		 */
		myEvents() {
			return this.events.filter(ev => {
				const isFuture = this.$moment().isBefore(ev.start.dateTime)
				const isSubscribed = ev.bSub
				const isDroppedLate = ev.bDropped
				return isFuture && (isSubscribed || isDroppedLate)
			})
		}
	},

	methods: {
		/**
		 * Show events
		 */
		showEventActions(event) {
			this.$pop.push({
				comp: EventAction,
				props: {event},
				on: {
					close: () => this.$pop.pop(),
					enroll: async () => {
						this.$pop.pop()
						this.$emit('enroll', event)
						await this.refreshProducts()  // 👈 aggiunto
					},
					dropout: async () => {
						this.$pop.pop()
						this.$emit('dropout', event)
						await this.refreshProducts()  // 👈 aggiunto
					}
				}
			})
		},
		async refreshProducts() {
			this.$emit('refresh-products')  // solo emetti l'evento!
		}
	}
}
</script>

<style lang="stylus" scoped>
.container
	background-color dark

	padding 2em

	overflow auto

	@media (max-width: unit(media-phone-max, px))
		padding 1em

.my-events
	padding 2em

	background-color dark

	.event
		display flex
		justify-items center

		margin 0.5em 0
		padding 1em
		border-radius 0.4em
		box-sizing border-box

		background-color mix(dark, darkish)
		color light

		font-size 1.2em

		&.past
			opacity 0.5
			filter grayscale(1)
		
		&.dropped
			border 2px solid coral
		
		.date
			padding-right 1em
			border-right 2px solid currentColor

			color primary

			text-align center

			.day
				font-size 2em
				font-weight bold

			.month
				color light

				font-size 1em
				font-weight bold

				text-transform uppercase
			
			.giorno
					color light

					font-weight bold

					text-transform uppercase
		
		&.dropped
			.date
				color coral
		
		.info
			flex-grow 1

			margin-left 1em

			.name
				color light

				font-size 1.8em
				font-weight bold
		
			.action-bar
				margin-top 0.2em
				font-size 0.9em

				.actions
					display inline-flex
					align-items center

					.drop-out
						display block

						border none
						padding 0.4em
						border-radius 50%

						background-color transparent
						color light

						font-family fontSans
						font-size 1em

						cursor pointer

						&:hover
							background-color darker
							color primary

.grid
	display grid
	grid-template-columns repeat(7, 1fr)
	grid-template-rows auto
	grid-gap 0.5em

	.day-literal
		padding 0.5em
		border-bottom 2px dashed secondary

		color secondary

		font-weight bold
		text-align center
		text-transform uppercase

	.month-day
		position relative

		padding 0.6em
		border-bottom 1px dashed darkish

		.day-number
			display flex
			justify-content center

			>span
				width 1.5em
				height 1.5em

				display flex
				justify-content center
				align-items center

				padding 0.2em
				border-radius 50%

				color secondary

				font-family fontSans
				font-weight bold

				text-align center

			&.today
				>span
					background-color primary
					color dark
		
		.day-events
			.disp1:not(.past)
				.numposti
					.posti
						font-size 0.75em
						color darkblue

						&:before
							content ' 1 posto disponibile'
			.disp2:not(.past)
				.numposti
					.posti
						font-size 0.75em
						color darkblue
						
						&:before
							content ' 2 posti disponibili'
			.disp3:not(.past)
				.numposti
					.posti
						font-size 0.75em
						color darkblue
						
						&:before
							content ' 3 posti disponibili'
			.disp4:not(.past)
				.numposti
					.posti
						font-size 0.75em
						color darkblue
						
						&:before
							content ' 4 posti disponibili'
			.disp5:not(.past)
				.numposti
					.posti
						font-size 0.75em
						color darkblue
						
						&:before
							content ' 5 posti disponibili'
			.disp6:not(.past)
				.numposti
					.posti
						font-size 0.75em
						color darkblue
						
						&:before
							content ' 6 posti disponibili'
			.event
				margin 0.4em 0
				padding 0.4em 0.6em
				border-radius 0.4em

				background-color mix(secondary, light)
				color dark

				cursor pointer

				.name
					margin-bottom 0.2em

					font-size 1.1em
					font-weight bold
				
				.info
					display flex
					align-items center

					.time
						margin-left 0.2em

					.availability
						&:before
							content 'Disponibile'

							white-space nowrap
				
				&.past
					opacity 0.5
					filter grayscale(1)

					cursor not-allowed
				&:not(.past)
					&.enrolled
						background-color primary

						.availability
							&:before
								content 'Prenotato'

					&:not(.enrolled)
						&.full
							opacity 0.5

							.availability
								&:before
									content 'Al completo'
						&.dropped
							border 2px solid coral

							background-color dark
							color light

							.availability
								&:before
									content 'Da recuperare entro 24h'
</style>